import React from 'react'
import PropTypes from 'prop-types'
import {community as communityText} from '../text'
import {business as businessText} from '../../../common/text'
import Container from '../../../common/components/Container'
import ObjectList from '../../../common/components/ObjectList'
import HeaderProgress from '../../../common/components/HeaderProgress'
import Title from './title'
import CategoryList from '../containers/categoryList'
import InfiniteScroll from '../../../common/components/InfiniteScroll'
import {Button} from '../../../components'

const ENABLE_INFINITE_SCROLL = false

class Community extends React.Component {

  tileClick = id => {
    this.props.history.push('/objetos/' + id)
  }

  loadMore = () => {
    const amount = 8
    this.props.setOffset(this.props.offset + amount)
    this.props.setLimit(amount)
    this.props.search()
  }

  render() {
    const {items, width, isSearching, expectMore} = this.props
    const shouldTriggerInfiniteScroll = ENABLE_INFINITE_SCROLL === true && isSearching === false && expectMore === true
    return (
      <Container>
        <InfiniteScroll shouldTrigger={shouldTriggerInfiniteScroll} trigger={this.loadMore}>
          <HeaderProgress show={isSearching}/>
          <Title gutterBottom={true}>{businessText.categories}</Title>
          <CategoryList/>
          <Title gutterBottom={true}>{communityText.popularObjects}</Title>
          <ObjectList
            items={items}
            width={width}
            handleTileClick={this.tileClick}
            showNoObjectsMessage={items.length === 0 && isSearching === false}
          />
          {expectMore === true && isSearching === false ? (
            <div style={{marginTop: 25, textAlign: 'center'}}>
              <Button variant={'primary'} onClick={this.loadMore}>{communityText.loadMore}</Button>
            </div>
          ) : null}
        </InfiniteScroll>
      </Container>
    )
  }

  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    offset: PropTypes.number,
    limit: PropTypes.number,
    expectMore: PropTypes.bool,
    setOffset: PropTypes.func.isRequired,
    setLimit: PropTypes.func.isRequired,
    isSearching: PropTypes.bool.isRequired,
    search: PropTypes.func.isRequired,
  }
}

export default Community



// WEBPACK FOOTER //
// ./src/sections/community/components/Community.js